'use client';

import { FunctionComponent } from 'react';

import { useRecommendedProducts } from '@/react/hooks/useRecommendedProducts';
import type { RecommendationContext } from '@/configs/recommendations';
import { InternalRecommendationsCarousel } from '../InternalRecommendationsCarousel';
import { IBaseRecommendationsCarouselProps } from '../IBaseRecommendationsCarouselProps';

export interface IRecommendationsCarouselProps
  extends IBaseRecommendationsCarouselProps {
  /**
   * The recommendation context to render.
   */
  context: RecommendationContext;
}

/**
 * Product recommendations carousel.
 */
export const RecommendationsCarousel: FunctionComponent<
  IRecommendationsCarouselProps
> = ({
  context,
  sliderProps,
  className,
  titleClassName,
  variant = 'default',
  contextData
}) => {
  const { products, title, isRecommendationEnabled, slots } =
    useRecommendedProducts({ context, contextData });

  if (!isRecommendationEnabled || !products.length) {
    return null;
  }

  return (
    <InternalRecommendationsCarousel
      products={products}
      slots={slots}
      title={title}
      sliderProps={sliderProps}
      className={className}
      titleClassName={titleClassName}
      variant={variant}
    />
  );
};
